import { Flex, Stack, VStack, Text } from "@chakra-ui/react";
import { Gallery } from "react-grid-gallery";

const Bread = () => {
  return (
    <div>
      {Hero()}
      <Gallery images={images} />
    </div>
  );
};

const Hero = () => {
  return (
    <Flex
      w={"full"}
      h={"50vh"}
      backgroundImage={require("../imgs/bread.jpg")}
      backgroundSize={"cover"}
      backgroundPosition={"center center"}
    >
      <VStack
        w={"full"}
        justify={"center"}
        px={{ base: 4, md: 8 }}
        bgGradient={"linear(to-r, blackAlpha.600, transparent)"}
      >
        <Stack maxW={"2xl"} align={"flex-start"} spacing={6}>
          <Text
            color={"white"}
            fontWeight={700}
            lineHeight={1.2}
            fontSize={{ base: "3xl", md: "4xl" }}
            textAlign="center"
          >
            Bread
          </Text>
          <Text
            color={"white"}
            fontWeight={300}
            lineHeight={1.2}
            fontSize={{ base: "md", md: "2md" }}
          >
            Tasty, Fresh and Baked Daily!
          </Text>
        </Stack>
      </VStack>
    </Flex>
  );
};


const images = [
  {
     src: require("../imgs/showcase/45.jpg"),
     width: 320,
     height: 200,
  },
  {
    src: require("../imgs/showcase/46.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/47.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/48.jpg"),
    width: 500,
    height: 500,
  },
  {
    src: require("../imgs/showcase/49.jpg"),
    width: 500,
    height: 500,
  },
];

export default Bread;
